module.exports = __webpack_public_path__ + "static/st2-3-6692d93df263e39ee78595aa8c43f423.jpg";